import React from 'react';

const V3PriorUncertainWarning = ({ count = 0 }) => count > 0 ? (
  <div role="status" className="mb-4 mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-900">
    {count.toLocaleString()} owners have an uncertain previous BatchData attempt and are being held for manual retry confirmation.
    {' '}They will not be automatically retried.
  </div>
) : null;

export default V3PriorUncertainWarning;
